import StudentLayout from '@/layouts/StudentLayout.vue';

const studentRoutes = [
  {
    path: '/student',
    component: StudentLayout,
    meta: { 
      requiresAuth: true,
      role: 'student'
    },
    children: [
      {
        path: '',
        name: 'StudentHome',
        component: () => import('@/views/student/Home.vue'),
        meta: { title: '学生首页' }
      },
      {
        path: 'performance',
        name: 'StudentPerformance',
        component: () => import('@/views/student/Performance.vue'),
        meta: { title: '表现记录' }
      },
      {
        path: 'wrong-questions',
        name: 'StudentWrongQuestions',
        component: () => import('@/views/student/WrongQuestionBooks.vue'),
        meta: { title: '错题本' }
      }
    ]
  },
  // 错题本详情路由 - 带校区代码路径
  {
    path: '/:schoolCode/:campusCode/student/wrong-questions/:bookId',
    name: 'StudentWrongQuestionBookDetail',
    component: () => import('@/views/student/WrongQuestionBookDetail.vue'),
    meta: {
      requiresAuth: true,
      role: 'student'
    }
  },
  // 错题本详情路由 - 只带学校代码路径
  {
    path: '/:schoolCode/student/wrong-questions/:bookId',
    name: 'StudentWrongQuestionBookDetailSchool',
    component: () => import('@/views/student/WrongQuestionBookDetail.vue'),
    meta: {
      requiresAuth: true,
      role: 'student'
    }
  },
  // 错题本详情路由 - 不带任何代码路径
  {
    path: '/student/wrong-questions/:bookId',
    name: 'StudentWrongQuestionBookDetailOnly',
    component: () => import('@/views/student/WrongQuestionBookDetail.vue'),
    meta: {
      requiresAuth: true,
      role: 'student'
    }
  }
];

export default studentRoutes; 